import React from 'react'
import PropTypes from 'prop-types'
import { FormControlLabel, Switch } from '@material-ui/core'

const FilterAllCities = (props) => {
  const { classes, checked, onChange } = props

  return (
    <div className={classes.allCitiesSwitchContainer}>
      <FormControlLabel
        control={
          <Switch
            size="small"
            color="primary"
            checked={checked}
            onChange={onChange}
          />
        }
        label="Toutes les villes"
      />
    </div>
  )
}

FilterAllCities.propTypes = {
  classes: PropTypes.object,
  checked: PropTypes.bool,
  onChange: PropTypes.func
}

export default FilterAllCities
